module.exports = __webpack_public_path__ + "img/vippack_dfod_k.c5f42426.png";